import React from 'react';

import getItemsPerRow from '../../../modules/getItemsPerRow';
import { HawkWidgetContext } from '../HawkWidget/HawkWidgetContext';
import type { HawkWidgetContextType } from '../HawkWidget/model';
import { Scroller } from '../Scroller/Scroller';

import HawkTab from './HawkTab';
import styles from './styles/hawk-tabs.css';
import { getDealsPerPage } from './utils/getDealsPerPage';
import { getTabsContainerStyle } from './utils/getTabsContainerStyle';
import { getIsSpecificNamedTab, SPECIFIC_TAB_COLORS } from './utils/specificTabColors';

export interface HawkTabsProps {
  className?: string;
  tabsScrollable?: boolean;
}

const HawkTabs: React.FC<HawkTabsProps> = ({ className, tabsScrollable }) => (
  <HawkWidgetContext.Consumer>
    {(value): JSX.Element | null => {
      const {
        tabs = [] as HawkWidgetContextType['tabs'],
        activeTab = {} as HawkWidgetContextType['activeTab'],
      } = value;

      if (tabs.length > 1 || activeTab.type === 'label_text_game_platform') {
        const isSpecificNamedTab = getIsSpecificNamedTab(tabs, activeTab);

        const containerStyle = getTabsContainerStyle(isSpecificNamedTab, styles, className);

        const pages = getItemsPerRow(tabs, getDealsPerPage());
        const tabColor = SPECIFIC_TAB_COLORS[activeTab.value];

        return (
          <div className={styles[containerStyle]}>
            <div className={styles.main}>
              {tabsScrollable && (
                <Scroller
                  items={tabs}
                  totalItems={tabs.length}
                  pagesLength={pages.length}
                  className="tabs-widget"
                >
                  {pages.map((pageTabs) => (
                    <div
                      className={styles['wrapper']}
                      key={pageTabs.map((tab) => tab.value).join('-')}
                    >
                      {pageTabs.map((tab) => (
                        <HawkTab
                          tab={tab}
                          isSpecificNamedTab={isSpecificNamedTab}
                          tabColor={SPECIFIC_TAB_COLORS[tab.value]}
                          isActive={tab.value === activeTab.value}
                          className={className}
                          key={tab.value}
                        />
                      ))}
                    </div>
                  ))}
                </Scroller>
              )}
              {!tabsScrollable &&
                tabs.map((tab) => (
                  <HawkTab
                    tab={tab}
                    isSpecificNamedTab={isSpecificNamedTab}
                    tabColor={SPECIFIC_TAB_COLORS[tab.value]}
                    isActive={tab.value === activeTab.value}
                    className={className}
                    key={tab.value}
                  />
                ))}
            </div>
            {activeTab.type === 'label_text_game_platform' && (
              <div
                className={styles['active-bar']}
                style={tabColor ? { backgroundColor: tabColor } : {}}
              />
            )}
          </div>
        );
      }

      return null;
    }}
  </HawkWidgetContext.Consumer>
);

export default HawkTabs;
